module.exports = __webpack_public_path__ + "img/multiplying_force.a9549533.png";